type TopVisibilityOptions = {
  topOffsetPx?: number
  bottomOffsetPx?: number
}

const isElementTopWithinViewport = (
  element: Element,
  { topOffsetPx = 0, bottomOffsetPx = 0 }: TopVisibilityOptions = {},
): boolean => {
  const { top: elementTopPx } = element.getBoundingClientRect()
  const viewportHeightPx =
    window.innerHeight || document.documentElement.clientHeight

  const viewportBottomPx = viewportHeightPx - bottomOffsetPx

  return elementTopPx >= topOffsetPx && elementTopPx <= viewportBottomPx
}

/**
 * Scrolls the element into view (aligning its top) only if the element's top edge
 * is currently outside the viewport, accounting for optional top/bottom offsets
 * (e.g. sticky header height). No-op when `element` is null/undefined.
 *
 * @param element - Target element to check/scroll. If null/undefined, does nothing.
 * @param options - Optional viewport offsets (in pixels) used to decide whether the
 * element's top is considered "visible".
 * @param options.topOffsetPx - Pixels to reserve from the top (e.g. sticky header height).
 * @param options.bottomOffsetPx - Pixels to reserve from the bottom of the viewport.
 */
export const scrollElementTopIntoViewIfTopIntoView = (
  element: Element | null | undefined,
  options: TopVisibilityOptions = {},
): void => {
  if (element) {
    const elementTopIsVisible = isElementTopWithinViewport(element, options)
    if (!elementTopIsVisible) {
      ;(element as HTMLElement).scrollIntoView(true)
    }
  }
}
